import { call, put, takeEvery } from 'redux-saga/effects';
import {RequestFailedUpdate, RequestLoadingUpdate, RequestSuccessfulUpdate} from "../../../request";
import {Post} from "../../../api";
import {
  UpdateEventsCohortReport,
   UpdateReportRequestState
} from "./action";
import {TransformReportResponse} from "./transformer";
import moment from 'moment';

export function* eventsSaga() {
  yield takeEvery('events-request-report', fetchReport);
}

function* fetchReport(action: any) {
  try {
    yield put(UpdateReportRequestState(RequestLoadingUpdate));
    // @ts-ignore
    const response = yield call(Post, '/dashboard/cohort', {
      from: moment(action.from).format("YYYY-MM-DD"),
      until: moment(action.until).format("YYYY-MM-DD"),
      isUnique: action.isUnique,
      filter: action.filter,
    });
    yield put(UpdateEventsCohortReport(TransformReportResponse(response)));
    yield put(UpdateReportRequestState(RequestSuccessfulUpdate));

  } catch (e) {
    yield put(UpdateReportRequestState(RequestFailedUpdate));

  }
}
